import { render, staticRenderFns } from "./JdsMeridian.vue?vue&type=template&id=39e4062e&scoped=true&"
import script from "./JdsMeridian.vue?vue&type=script&lang=ts&"
export * from "./JdsMeridian.vue?vue&type=script&lang=ts&"
import style0 from "./JdsMeridian.vue?vue&type=style&index=0&id=39e4062e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e4062e",
  null
  
)

export default component.exports